import { render, staticRenderFns } from "./Redeems.vue?vue&type=template&id=76fd5608&lang=pug"
import script from "./Redeems.vue?vue&type=script&lang=js"
export * from "./Redeems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports